module.exports = __webpack_public_path__ + "media/customizations/rianoridge/logo-3b186699baf9df3af527706e4b2a2457.png";